// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/result/style/index.less
// module id = 1780
// module chunks = 0